module.exports = __webpack_public_path__ + "img/icon_arrow-left.b98159e1.svg";